import { Id, PagedMultiSelectField, laravelSelectFetchConfig } from "@dgs/core";
import { FC, useMemo } from "react";
import { createApplicationUserService } from "../shared/api/userService";

interface Props {
	applicationId: Id;
	name: string;
	label: string;
	disabled?: boolean;
	clearable?: boolean;
	required?: boolean;
}

export const ApplicationUserGroupMultiSelect: FC<Props> = ({
	applicationId,
	name,
	label,
	disabled,
	clearable,
	required = false,
}) => {
	const applicationUserService = useMemo(() => createApplicationUserService(applicationId), [applicationId]);

	return (
		<PagedMultiSelectField
			name={name}
			label={label}
			fetchConfig={laravelSelectFetchConfig(applicationUserService.getAvailableUserGroupsKey, (search, page) =>
				applicationUserService.getAvailableUserGroups(search, page).then((r) => r.data),
			)}
			disabled={disabled}
			clearable={clearable}
			required={required}
		/>
	);
};
